import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { resetSelectedMapStops } from '~/reducers/selectedMapStopsSlice';
import { resetSelectedMapRoutes } from '~/reducers/selectedMapRoutesSlice';
import {
    setIsOpenSuggestDrawer,
    setIsOpenUnassignedTasksDrawer
} from '~/reducers/mapDrawerSettingsSlice';
import { useIsolatedRoutes, useMapUtils } from '~/hooks';
import { setMapMarkerMode } from '~/reducers/mapSettingsSlice';
import constants from '~/utils/constants';

export const useSelectRoutesView = () => {
    const { isPlanRouteMode } = useMapUtils();
    const { isolateMultipleRoutes } = useIsolatedRoutes();
    const dispatch = useDispatch();

    const selectRoutesView = useCallback(() => {
        dispatch(resetSelectedMapStops());
        dispatch(resetSelectedMapRoutes([]));
        dispatch(setIsOpenUnassignedTasksDrawer(false));
        dispatch(setIsOpenSuggestDrawer(false));
        isolateMultipleRoutes(false);

        if (isPlanRouteMode) {
            dispatch(setMapMarkerMode(constants.mapMarkerModes.ROUTES));
        }
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [isPlanRouteMode]);

    return {
        selectRoutesView
    };
};
